import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../store/store";
import { isTokenValid } from "../utils/isTokenValid";
import { LOGIN_CHOICE } from "../views/auth/routes";

const FreelancerOrShareRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  // Campo `accessToken`, o mesmo nome que o slice grava (ver BUG-006).
  const freelancerToken = useSelector((s: RootState) => s.freelancerAuth?.accessToken);

  if (!rehydrated) return null;

  const share = new URLSearchParams(location.search).get("share");
  if (share) return <>{children}</>;

  const freelancerValid = isTokenValid(freelancerToken);
  if (freelancerValid) return <>{children}</>;

  return <Navigate to={LOGIN_CHOICE()} replace />;
};

export default FreelancerOrShareRoute;
